import { useEffect, useState } from 'react';
import Layout from '../../Components/Layout/Layout';
import { useNavigate, useParams } from 'react-router-dom';
import GetDataApi from '../../Components/Common/FetchData/GetDataApi';
import { Container, Row, Col } from 'react-bootstrap';
import { FaGlobe, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { imgUrl } from '../../Helpers/Constant';
import { MdOutlineEmail } from 'react-icons/md';
import CommonProductServiceCard from './CommonProductServiceCard';
import PostDataApis from '../../Components/Common/FetchData/PostDataApis';
import ProductDetailsWithModal from './ProductDetailsWithModal';
import { VisitorAuthContext } from '../../Context/AuthContex/VisitorAuthContext';
import {
  TExhibitorProductAndServiceDetails,
  TPublicProductAndServiceList,
} from './apiEndpoints/pubAndSerTypes';
const ExhibitorProductAndServiceDetails = () => {
  const { id } = useParams();
  const { visitorUser, dispatch } = VisitorAuthContext();
  const navigate = useNavigate();
  const { getData, response } = GetDataApi<TExhibitorProductAndServiceDetails>(
    `/api/fair/member-products/${id}`,
    true
  );
  useEffect(() => {
    if (id) {
      getData();
    }
  }, []);

  const { postData, success, setSuccess } = PostDataApis(
    '/api/fair/visitor/wishlist'
  );

  const checkVisitor = (id: number) => {
    if (!Object?.keys(visitorUser)?.length) {
      navigate('/visitor-login');
    } else {
      postData({ product_id: id });
    }
  };

  useEffect(() => {
    if (success) {
      getData();

      setSuccess(false);
    }
  }, [success]);
  useEffect(() => {
    getData();
  }, []);

  const [show, setShow] = useState(false);
  const [data, setData] = useState<TPublicProductAndServiceList>();
  return (
    <Layout
      pathName={`Exhibitor - ${response?.user_fair_member_company_name}`}
      showHeader
    >
      <div>
        <Container className='my-'>
          <Row className='mb-4'>
            <Col xs={12} md={2}>
              <div
                style={{
                  overflow: 'hidden',
                  width: '100%',
                  textAlign: 'center',
                  border: '1px solid gray',
                }}
              >
                <img
                  src={imgUrl + '/' + response?.user_fair_member_company_logo}
                  alt='Company Logo'
                  style={{
                    width: '120px',
                    height: 'auto',
                  }}
                />
              </div>
            </Col>
            <Col md={10}>
              <h2>{response?.user_fair_member_company_name}</h2>

              <Row>
                <Col md={4} lg={3} xl={3}>
                  {' '}
                  <FaGlobe size={14} />{' '}
                  <a
                    style={{ textDecoration: 'none' }}
                    href={response?.user_fair_member_company_website}
                  >
                    {response?.user_fair_member_company_website}
                  </a>
                </Col>
                <Col md={5} lg={4} xl={4}>
                  {' '}
                  <MdOutlineEmail size={16} />{' '}
                  {response?.user_fair_member_company_email}
                </Col>
                <Col md={4} lg={3} xl={2}>
                  {' '}
                  <FaPhone size={12} />{' '}
                  {response?.user_fair_member_company_telephone}
                </Col>
                <Col xs={12} className='mt-2'>
                  {' '}
                  <FaMapMarkerAlt size={14} />{' '}
                  {response?.user_fair_member_company_address}
                </Col>
              </Row>
            </Col>
          </Row>

          {/* Company Details */}
          {/* <Row className='mb-4'>
            <Col xs={12} md={2}></Col>
            <Col>
              <h4>Company Details</h4>
              <p>{response?.user_fair_member_company_details}</p>
            </Col>
          </Row> */}
          <Row>
            <Col xs={12} md={2}></Col>
            <Col xs={10}>
              <div>
                <ProductDetailsWithModal
                  show={show}
                  setShow={setShow}
                  data={data}
                />
                <h4>Product & Services</h4>
                <CommonProductServiceCard
                  response={response?.product}
                  checkVisitor={(id) => {
                    checkVisitor(id);
                  }}
                  getData={(data) => {
                    setShow(!show);
                    setData(data);
                  }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default ExhibitorProductAndServiceDetails;
